import React from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Icon,
  Dropdown,
  Input,
  Divider,
  Badge
} from 'antd';
import { isEmpty } from 'lodash';
import customDashboards from '../../extensions/dashboards/customDashboards';

import formRender from '../formRender';
import { checkBehaviour } from '../behaviourUtils';

import { buttonsContainerBottom } from './searchFormButtons';
import * as customButtonsFile from '../../extensions/buttons/customButtons';
import { getModifiedFieldsNumber } from '../formConstructor';
import '../FormStyles.css';

const ButtonGroup = Button.Group;

const checkButtonPermissions = (button, userPermissions) => {
  let disabled;
  userPermissions.forEach(permission => {
    button.permissions.forEach(perm => {
      if (permission === perm.name) {
        disabled = perm.disabled;
      }
    });
  });
  return disabled;
};

const checkButtonBehaviours = (button, values) => {
  let disabled;
  button.behaviours.forEach(behaviour => {
    if (checkBehaviour(behaviour, values)) disabled = !button.defaultDisabled;
  });
  if (disabled === undefined) return button.defaultDisabled;
  else return disabled;
};

const checkDisabledButton = (button, values, userPermissions) => {
  let disabled;

  if (typeof button === 'object') {
    button.permissions
      ? (disabled = checkButtonPermissions(button, userPermissions))
      : (disabled = checkButtonBehaviours(button, values));
    if (disabled === undefined) disabled = button.defaultDisabled;
  } else if (button === undefined) {
    return false;
  } else disabled = !button;

  return disabled;
};

export default function searchFormRender(parentProps) {
  const componentProps =
    parentProps.props.customDashboard &&
    customDashboards[parentProps.props.customDashboard] &&
    customDashboards[parentProps.props.customDashboard].search
      ? customDashboards[parentProps.props.customDashboard].search(parentProps)
      : { ...parentProps };

  const { handleChangeField, globalSearchField } = componentProps;

  return (
    <Form className="form" onSubmit={componentProps.handleSubmit}>
      <Row className="form__front">
        <Col
          xs={12}
          sm={10}
          md={8}
          lg={6}
          xl={6}
          xxl={6}
          key={globalSearchField.type}
        >
          <Form.Item>
            {componentProps.props.form.getFieldDecorator(
              globalSearchField.key,
              {
                initialValue: componentProps.props.values[globalSearchField.key]
              }
            )(
              <Input.Search
                type={globalSearchField.type}
                title={globalSearchField.key}
                style={{ verticalAlign: 'top' }}
                placeholder={globalSearchField.title}
                onBlur={e =>
                  handleChangeField({
                    type: globalSearchField.type,
                    id: globalSearchField.key,
                    value: e.target.value
                  })
                }
                enterButton={<Button icon="search" htmlType="submit" />}
                allowClear
              />
            )}
          </Form.Item>
        </Col>
        <ButtonGroup style={{ marginTop: '-1.5px' }}>
          {dropDownButton(componentProps)}
          {cleanButton(componentProps)}
        </ButtonGroup>
        {(componentProps.props.layoutType === 0 ||
          componentProps.props.layoutType === 1) &&
          addNewRecordButton(componentProps)}
      </Row>
    </Form>
  );
}

const dropDownButton = componentProps => {
  const count = getModifiedFieldsNumber(
    componentProps.props.fields,
    componentProps.props.values
  );
  return (
    <Dropdown
      overlay={dropDownFields(componentProps)}
      trigger={['click']}
      placement="bottomCenter"
      overlayClassName="formDropdown"
      visible={componentProps.props.filterVisible}
    >
      {isEmpty(componentProps.props.fields) ? null : (
        <Badge
          count={count}
          title={`Se han aplicado ${count} filtros de búsqueda`}
          style={{ backgroundColor: '#faad14' }}
        >
          <Button
            size="default"
            onClick={() =>
              componentProps.handleChangeFilterVisibility(
                !componentProps.props.filterVisible
              )
            }
          >
            {componentProps.props.intl.formatMessage({ id: 'form.filter' })}
            <Icon type="sliders" />
          </Button>
        </Badge>
      )}
    </Dropdown>
  );
};

const dropDownFields = componentProps => {
  const { customButtons } = componentProps.props.params;
  return (
    <>
      <Row>
        {customButtons
          ? customButtons.map(customButton =>
              customButtonsFile[customButton](componentProps)
            )
          : null}
      </Row>
      {formRender(componentProps)}
      <Divider className="form__divider" />

      {buttonsContainerBottom ? buttonsContainerBottom(componentProps) : null}
    </>
  );
};

const cleanButton = componentProps => {
  const { handleReset } = componentProps;
  return (
    <Button onClick={handleReset}>
      <Icon type="highlight" />
    </Button>
  );
};

const addNewRecordButton = componentProps => {
  const { values, userPermissions, options } = componentProps.props;
  const { canCreate } = options;
  const addDisabled = checkDisabledButton(canCreate, values, userPermissions);

  return (
    <Button
      icon="file-add"
      disabled={addDisabled}
      type="primary"
      style={{ float: 'right' }}
      onClick={componentProps.handleAddData}
      title={componentProps.props.intl.formatMessage({ id: 'form.new' })}
    >
      {componentProps.props.intl.formatMessage({ id: 'form.new' })}
    </Button>
  );
};
